// import React, { useEffect, useState } from "react";

// import { useParams, useSearchParams } from "react-router-dom";

// import { useLocation } from "react-router-dom";

// import axios from "../../api/axiosinstance";
// import PackageApi from "../../api/PackageApi";
// import LeadFinalApi from "../../api/leadFinalApi";

// import { showError, showSuccess } from "../../utils/toastUtils";

// import ClientFlowLayout from "../../layout/clientFlow/ClientFlowLayout";

// import ClientInfoCard from "../../components/clientFlow/ClientInfoCard";

// import QuoteCard from "../../components/clientFlow/QuoteCard";

// import ModuleList from "../../components/clientFlow/ModuleList";

// import ActionButton from "../../components/clientFlow/ActionButton";

// function CreateDocument() {
//   const { leadId } = useParams();

//   const [searchParams] = useSearchParams();

//   const packageId = searchParams.get("packageId");

//   const location = useLocation();

//   const passedCommitments = location.state?.commitments || [];

//   const subDisposition = location.state?.sub_disposition || "";

//   const passedPrice = location.state?.price || "";

//   const [features, setFeatures] = useState([]);

//   const [packageName, setPackageName] = useState("");

//   const [lead, setLead] = useState(null);

//   const [commitments, setCommitments] = useState([]);

//   const [price, setPrice] = useState(passedPrice);

//   const [documentId, setDocumentId] = useState("");

//   const [link, setLink] = useState("");

//   const [creating, setCreating] = useState(false);

//   const [sending, setSending] = useState(false);

//   const [isEditing, setIsEditing] = useState(false);
//   const disposition = location.state?.disposition || "";

//   useEffect(() => {
//     if (passedCommitments.length) {
//       setCommitments(passedCommitments);
//     }
//   }, [passedCommitments]);

//   useEffect(() => {
//     if (packageId) {
//       fetchPackage();
//     }

//     if (leadId) {
//       fetchLead();
//     }
//   }, [packageId, leadId]);

// const fetchPackage = async () => {
//   try {
//     const res = await PackageApi.list();

//     console.log("PACKAGE API RESPONSE", res.data);

//     if (res.data.code === 200) {
//       const packages = res.data.data;

//     const selected = packages.find(
//   (p) => String(p._id) === String(packageId)
// );

//       console.log("PACKAGE ID FROM URL:", packageId);
// console.log(
//   "PACKAGE IDS:",
//   packages.map((p) => p._id)
// );
// console.log("SELECTED:", selected);

//     console.log("SELECTED", selected);
// console.log("MODULES", selected?.modules);
// console.log("FEATURES BEFORE SAVE", features);
//       if (selected) {
//         setPackageName(selected.packageName);
//         setFeatures(selected.modules);
//       }
//     }
//   } catch (err) {
//     console.log(err);
//     showError("Failed to load package");
//   }
// };

//   const fetchLead = async () => {
//     try {
//       const res = await LeadFinalApi.details(leadId);

//       if (res.code === 200) {
//         setLead(res.data);
//       }
//     } catch {
//       showError("Failed to load lead");
//     }
//   };

//   const handleCreateDocument = async () => {
//     try {
//       setCreating(true);

//       const res = await axios.post("/documents/add", {
//         leadId,
//         features,

//         commitments:
//           disposition === "Proposal with Add-ons"
//             ? commitments.filter(
//                 (c) => c.moduleName || c.description || c.price,
//               )
//             : [],

//         price: price || 0,
//       });

//       const documentData = res.data || res;

//       if (res.code === 200 && documentData?._id) {
//         const id = documentData._id;

//         setDocumentId(id);

//         const generatedLink = `${window.location.origin}/document/view/${id}`;

//         setLink(generatedLink);

//         showSuccess("Document created successfully");
//       } else {
//         showError("Document create failed");
//       }
//     } catch (err) {
//       console.log(err);

//       showError(err.message || "Something went wrong");
//     } finally {
//       setCreating(false);
//     }
//   };

//   const handleSendMail = async () => {
//     try {
//       setSending(true);

//       const res = await axios.post("/documents/send-mail", {
//         email: lead?.email,
//         documentId,
//       });

//       if (res.code === 200) {
//         showSuccess("Link sent successfully");
//       } else {
//         showError("Mail failed");
//       }
//     } catch {
//       showError("Server error");
//     } finally {
//       setSending(false);
//     }
//   };

//   const handleCopyLink = () => {
//     navigator.clipboard.writeText(link);

//     showSuccess("Link copied");
//   };

//   const additionalTotal = commitments.reduce(
//     (total, item) => total + Number(item.price || 0),
//     0,
//   );

//   const finalTotal = Number(price || 0) + additionalTotal;

//   return (
//     <ClientFlowLayout
//       rightContent={
//         <>
//           <ClientInfoCard
//             lead={lead}
//             proposalId={documentId || "Generating..."}
//           />

//           <QuoteCard />

//           <div
//             style={{
//               marginTop: "25px",
//               display: "flex",
//               justifyContent: "center",
//             }}
//           >
//             <img
//               src="/assets/img/ecommerce-proposal.png"
//               alt=""
//               style={{
//                 width: "100%",
//                 maxWidth: "520px",
//                 objectFit: "contain",
//               }}
//             />
//           </div>
//         </>
//       }
//       footerButtons={
//         <>
//           {/* EDIT MODE BUTTONS */}

//           {!documentId && !isEditing && (
//             <>
//               <ActionButton
//                 title="✏️ Edit"
//                 outline
//                 onClick={() => setIsEditing(true)}
//               />

//               <ActionButton
//                 title="🚀 Create"
//                 onClick={handleCreateDocument}
//                 loading={creating}
//               />
//             </>
//           )}

//           {/* SAVE + CANCEL */}

//           {!documentId && isEditing && (
//             <>
//               <ActionButton
//                 title="✅ Save"
//                 onClick={() => setIsEditing(false)}
//               />

//               <ActionButton
//                 title="❌ Cancel"
//                 outline
//                 onClick={() => setIsEditing(false)}
//               />
//             </>
//           )}

//           {/* AFTER CREATE */}

//           {documentId && (
//             <>
//               <ActionButton
//                 title="📩 Send Link"
//                 onClick={handleSendMail}
//                 loading={sending}
//               />

//               <ActionButton
//                 title="🔗 Copy Link"
//                 onClick={handleCopyLink}
//                 outline
//               />

//               <a
//                 href={link}
//                 target="_blank"
//                 rel="noreferrer"
//                 style={{
//                   textDecoration: "none",
//                 }}
//               >
//                 <ActionButton title="👁 Preview" outline />
//               </a>
//             </>
//           )}
//         </>
//       }
//     >
//       {/* DESCRIPTION */}

//       <div
//         style={{
//           fontSize: "15px",
//           lineHeight: "32px",
//           color: "#4b4b4b",
//           marginBottom: "35px",
//         }}
//       >
//         We are excited to present this proposal for your consideration. This
//         document outlines the scope, deliverables, timeline and our approach to
//         deliver exceptional results.
//       </div>

//       {/* INCLUDED MODULES */}

//       <ModuleList title="Included Modules" items={features} />

//       {/* ADDITIONAL MODULES */}

//       {subDisposition === "Additional Commitments" && (
//         <div
//           style={{
//             marginTop: "35px",
//           }}
//         >
//           <h3
//             style={{
//               color: "#5a140c",
//               marginBottom: "18px",
//               fontSize: "24px",
//               fontWeight: "700",
//             }}
//           >
//             Additional Modules
//           </h3>

//           {/* ADD BUTTON */}

//           {isEditing && (
//             <button
//               onClick={() =>
//                 setCommitments([
//                   ...commitments,
//                   {
//                     moduleName: "",
//                     description: "",
//                     price: "",
//                   },
//                 ])
//               }
//               style={{
//                 border: "none",
//                 background: "#7b1408",
//                 color: "#fff",
//                 padding: "10px 18px",
//                 borderRadius: "8px",
//                 marginBottom: "20px",
//                 cursor: "pointer",
//                 fontWeight: "600",
//               }}
//             >
//               ➕ Add Module
//             </button>
//           )}

//           {commitments.map((c, i) => (
//             <div
//               key={i}
//               style={{
//                 border: "1px solid #eaded8",
//                 borderRadius: "14px",
//                 padding: "18px",
//                 marginBottom: "18px",
//                 background: "#fff",
//               }}
//             >
//               {/* MODULE NAME */}

//               <div
//                 style={{
//                   marginBottom: "14px",
//                 }}
//               >
//                 <label
//                   style={{
//                     fontWeight: "600",
//                     display: "block",
//                     marginBottom: "7px",
//                     color: "#5a140c",
//                   }}
//                 >
//                   Module Name
//                 </label>

//                 {isEditing ? (
//                   <input
//                     type="text"
//                     value={c.moduleName}
//                     onChange={(e) => {
//                       const updated = [...commitments];

//                       updated[i].moduleName = e.target.value;

//                       setCommitments(updated);
//                     }}
//                     style={{
//                       width: "100%",
//                       padding: "12px",
//                       border: "1px solid #ddd",
//                       borderRadius: "8px",
//                     }}
//                   />
//                 ) : (
//                   <div>{c.moduleName}</div>
//                 )}
//               </div>

//               {/* DESCRIPTION */}

//               <div
//                 style={{
//                   marginBottom: "14px",
//                 }}
//               >
//                 <label
//                   style={{
//                     fontWeight: "600",
//                     display: "block",
//                     marginBottom: "7px",
//                     color: "#5a140c",
//                   }}
//                 >
//                   Description
//                 </label>

//                 {isEditing ? (
//                   <textarea
//                     rows={3}
//                     value={c.description}
//                     onChange={(e) => {
//                       const updated = [...commitments];

//                       updated[i].description = e.target.value;

//                       setCommitments(updated);
//                     }}
//                     style={{
//                       width: "100%",
//                       padding: "12px",
//                       border: "1px solid #ddd",
//                       borderRadius: "8px",
//                       resize: "none",
//                     }}
//                   />
//                 ) : (
//                   <div
//                     style={{
//                       lineHeight: "28px",
//                       color: "#555",
//                     }}
//                   >
//                     {c.description}
//                   </div>
//                 )}
//               </div>

//               {/* PRICE */}

//               <div>
//                 <label
//                   style={{
//                     fontWeight: "600",
//                     display: "block",
//                     marginBottom: "7px",
//                     color: "#5a140c",
//                   }}
//                 >
//                   Price
//                 </label>

//                 {isEditing ? (
//                   <input
//                     type="number"
//                     value={c.price}
//                     onChange={(e) => {
//                       const updated = [...commitments];

//                       updated[i].price = e.target.value;

//                       setCommitments(updated);
//                     }}
//                     style={{
//                       width: "100%",
//                       padding: "12px",
//                       border: "1px solid #ddd",
//                       borderRadius: "8px",
//                     }}
//                   />
//                 ) : (
//                   <div
//                     style={{
//                       color: "#7b1408",
//                       fontWeight: "700",
//                       fontSize: "18px",
//                     }}
//                   >
//                     ₹ {c.price || 0}
//                   </div>
//                 )}
//               </div>

//               {/* DELETE */}

//               {isEditing && (
//                 <button
//                   onClick={() => {
//                     const updated = commitments.filter(
//                       (_, index) => index !== i,
//                     );

//                     setCommitments(updated);
//                   }}
//                   style={{
//                     marginTop: "15px",
//                     border: "none",
//                     background: "#dc2626",
//                     color: "#fff",
//                     padding: "10px 15px",
//                     borderRadius: "8px",
//                     cursor: "pointer",
//                   }}
//                 >
//                   🗑 Remove
//                 </button>
//               )}
//             </div>
//           ))}
//         </div>
//       )}

//       {/* TOTAL PRICE */}

//       <div
//         style={{
//           marginTop: "35px",
//         }}
//       >
//         <h3
//           style={{
//             color: "#5a140c",
//             marginBottom: "18px",
//             fontSize: "24px",
//             fontWeight: "700",
//           }}
//         >
//           Total Price
//         </h3>

//         <div
//           style={{
//             border: "1px solid #eaded8",
//             borderRadius: "14px",
//             padding: "22px",
//             background: "#fff",
//           }}
//         >
//           {isEditing ? (
//             <input
//               type="number"
//               value={price}
//               onChange={(e) => setPrice(e.target.value)}
//               style={{
//                 width: "100%",
//                 padding: "14px",
//                 border: "1px solid #ddd",
//                 borderRadius: "8px",
//                 fontSize: "18px",
//               }}
//             />
//           ) : (
//             <div
//               style={{
//                 color: "#7b1408",
//                 fontSize: "28px",
//                 fontWeight: "700",
//               }}
//             >
//               ₹ {Number(finalTotal || 0).toLocaleString("en-IN")}
//             </div>
//           )}
//         </div>
//       </div>
//     </ClientFlowLayout>
//   );
// }

// export default CreateDocument;

import React, { useEffect, useState } from "react";

import { useParams, useSearchParams } from "react-router-dom";

import { useLocation } from "react-router-dom";

import axios from "../../api/axiosinstance";
import PackageApi from "../../api/PackageApi";
import LeadFinalApi from "../../api/leadFinalApi";

import { showError, showSuccess } from "../../utils/toastUtils";

import ClientFlowLayout from "../../layout/clientFlow/ClientFlowLayout";

import ClientInfoCard from "../../components/clientFlow/ClientInfoCard";

import QuoteCard from "../../components/clientFlow/QuoteCard";

import ModuleList from "../../components/clientFlow/ModuleList";

import ActionButton from "../../components/clientFlow/ActionButton";

function CreateDocument() {
  const { leadId } = useParams();

  const [searchParams] = useSearchParams();

  const packageId = searchParams.get("packageId");

  const location = useLocation();

  const sessionData = JSON.parse(
    sessionStorage.getItem("proposalState") || "{}",
  );

  const routeState = location.state || sessionData;

  const passedCommitments = routeState.commitments || [];

  const subDisposition = routeState.sub_disposition || "";

  const passedPrice = routeState.price || "";

  const disposition = routeState.disposition || "";

  const [features, setFeatures] = useState([]);

  const [packageName, setPackageName] = useState("");

  const [lead, setLead] = useState(null);

  const [commitments, setCommitments] = useState([]);

  const [price, setPrice] = useState(passedPrice);

  const [documentId, setDocumentId] = useState("");

  const [link, setLink] = useState("");

  const [creating, setCreating] = useState(false);

  const [sending, setSending] = useState(false);

  const [isEditing, setIsEditing] = useState(false);

  useEffect(() => {
    if (passedCommitments.length) {
      setCommitments(passedCommitments);
    }
  }, [passedCommitments]);

  useEffect(() => {
    if (packageId) {
      fetchPackage();
    }

    if (leadId) {
      fetchLead();
    }
  }, [packageId, leadId]);

  useEffect(() => {
    return () => {
      sessionStorage.removeItem("proposalState");
    };
  }, []);

  const fetchPackage = async () => {
    try {
      const res = await PackageApi.list();

      if (res.code === 200) {
        const selected = res.data.find((p) => p._id === packageId);

        if (selected) {
          setPackageName(selected.packageName);

          const modules = selected.modules.map(
            (m) => `${m.moduleName} - ${m.description || ""}`,
          );

          setFeatures(modules);
        }
      }
    } catch {
      showError("Failed to load package");
    }
  };

  const fetchLead = async () => {
    try {
      const res = await LeadFinalApi.details(leadId);

      if (res.code === 200) {
        setLead(res.data);
      }
    } catch {
      showError("Failed to load lead");
    }
  };

  const handleCreateDocument = async () => {
    try {
      setCreating(true);

      const res = await axios.post("/documents/add", {
        leadId,
        features,

        commitments:
          disposition === "Proposal with Add-ons"
            ? commitments.filter(
                (c) => c.moduleName || c.description || c.price,
              )
            : [],

        price: price || 0,
      });

      const documentData = res.data || res;

      if (res.code === 200 && documentData?._id) {
        const id = documentData._id;

        setDocumentId(id);

        const generatedLink = `${window.location.origin}/document/view/${id}`;

        setLink(generatedLink);

        showSuccess("Document created successfully");
      } else {
        showError("Document create failed");
      }
    } catch (err) {
      console.log(err);

      showError(err.message || "Something went wrong");
    } finally {
      setCreating(false);
    }
  };

  const handleSendMail = async () => {
    try {
      setSending(true);

      const res = await axios.post("/documents/send-mail", {
        email: lead?.email,
        documentId,
      });

      if (res.code === 200) {
        showSuccess("Link sent successfully");
      } else {
        showError("Mail failed");
      }
    } catch {
      showError("Server error");
    } finally {
      setSending(false);
    }
  };

  const handleCopyLink = () => {
    navigator.clipboard.writeText(link);

    showSuccess("Link copied");
  };

  const additionalTotal = commitments.reduce(
    (total, item) => total + Number(item.price || 0),
    0,
  );

  const finalTotal = Number(price || 0) + additionalTotal;

  return (
    <ClientFlowLayout
      rightContent={
        <>
          <ClientInfoCard
            lead={lead}
            proposalId={documentId || "Generating..."}
          />

          <QuoteCard />

          <div
            style={{
              marginTop: "25px",
              display: "flex",
              justifyContent: "center",
            }}
          >
            <img
              src="/assets/img/ecommerce-proposal.png"
              alt=""
              style={{
                width: "100%",
                maxWidth: "520px",
                objectFit: "contain",
              }}
            />
          </div>
        </>
      }
      footerButtons={
        <>
          {/* EDIT MODE BUTTONS */}

          {!documentId && !isEditing && (
            <>
              <ActionButton
                title="✏️ Edit"
                outline
                onClick={() => setIsEditing(true)}
              />

              <ActionButton
                title="🚀 Create"
                onClick={handleCreateDocument}
                loading={creating}
              />
            </>
          )}

          {/* SAVE + CANCEL */}

          {!documentId && isEditing && (
            <>
              <ActionButton
                title="✅ Save"
                onClick={() => setIsEditing(false)}
              />

              <ActionButton
                title="❌ Cancel"
                outline
                onClick={() => setIsEditing(false)}
              />
            </>
          )}

          {/* AFTER CREATE */}

          {documentId && (
            <>
              <ActionButton
                title="📩 Send Link"
                onClick={handleSendMail}
                loading={sending}
              />

              <ActionButton
                title="🔗 Copy Link"
                onClick={handleCopyLink}
                outline
              />

              <a
                href={link}
                target="_blank"
                rel="noreferrer"
                style={{
                  textDecoration: "none",
                }}
              >
                <ActionButton title="👁 Preview" outline />
              </a>
            </>
          )}
        </>
      }
    >
      {/* DESCRIPTION */}

      <div
        style={{
          fontSize: "15px",
          lineHeight: "32px",
          color: "#4b4b4b",
          marginBottom: "35px",
        }}
      >
        We are excited to present this proposal for your consideration. This
        document outlines the scope, deliverables, timeline and our approach to
        deliver exceptional results.
      </div>

      {/* INCLUDED MODULES */}

      <ModuleList title="Included Modules" items={features} />

      {/* ADDITIONAL MODULES */}

      {subDisposition === "Additional Commitments" && (
        <div
          style={{
            marginTop: "35px",
          }}
        >
          <h3
            style={{
              color: "#5a140c",
              marginBottom: "18px",
              fontSize: "24px",
              fontWeight: "700",
            }}
          >
            Additional Modules
          </h3>

          {/* ADD BUTTON */}

          {isEditing && (
            <button
              onClick={() =>
                setCommitments([
                  ...commitments,
                  {
                    moduleName: "",
                    description: "",
                    price: "",
                  },
                ])
              }
              style={{
                border: "none",
                background: "#7b1408",
                color: "#fff",
                padding: "10px 18px",
                borderRadius: "8px",
                marginBottom: "20px",
                cursor: "pointer",
                fontWeight: "600",
              }}
            >
              ➕ Add Module
            </button>
          )}

          {commitments.map((c, i) => (
            <div
              key={i}
              style={{
                border: "1px solid #eaded8",
                borderRadius: "14px",
                padding: "18px",
                marginBottom: "18px",
                background: "#fff",
              }}
            >
              {/* MODULE NAME */}

              <div
                style={{
                  marginBottom: "14px",
                }}
              >
                <label
                  style={{
                    fontWeight: "600",
                    display: "block",
                    marginBottom: "7px",
                    color: "#5a140c",
                  }}
                >
                  Module Name
                </label>

                {isEditing ? (
                  <input
                    type="text"
                    value={c.moduleName}
                    onChange={(e) => {
                      const updated = [...commitments];

                      updated[i].moduleName = e.target.value;

                      setCommitments(updated);
                    }}
                    style={{
                      width: "100%",
                      padding: "12px",
                      border: "1px solid #ddd",
                      borderRadius: "8px",
                    }}
                  />
                ) : (
                  <div>{c.moduleName}</div>
                )}
              </div>

              {/* DESCRIPTION */}

              <div
                style={{
                  marginBottom: "14px",
                }}
              >
                <label
                  style={{
                    fontWeight: "600",
                    display: "block",
                    marginBottom: "7px",
                    color: "#5a140c",
                  }}
                >
                  Description
                </label>

                {isEditing ? (
                  <textarea
                    rows={3}
                    value={c.description}
                    onChange={(e) => {
                      const updated = [...commitments];

                      updated[i].description = e.target.value;

                      setCommitments(updated);
                    }}
                    style={{
                      width: "100%",
                      padding: "12px",
                      border: "1px solid #ddd",
                      borderRadius: "8px",
                      resize: "none",
                    }}
                  />
                ) : (
                  <div
                    style={{
                      lineHeight: "28px",
                      color: "#555",
                    }}
                  >
                    {c.description}
                  </div>
                )}
              </div>

              {/* PRICE */}

              <div>
                <label
                  style={{
                    fontWeight: "600",
                    display: "block",
                    marginBottom: "7px",
                    color: "#5a140c",
                  }}
                >
                  Price
                </label>

                {isEditing ? (
                  <input
                    type="number"
                    value={c.price}
                    onChange={(e) => {
                      const updated = [...commitments];

                      updated[i].price = e.target.value;

                      setCommitments(updated);
                    }}
                    style={{
                      width: "100%",
                      padding: "12px",
                      border: "1px solid #ddd",
                      borderRadius: "8px",
                    }}
                  />
                ) : (
                  <div
                    style={{
                      color: "#7b1408",
                      fontWeight: "700",
                      fontSize: "18px",
                    }}
                  >
                    ₹ {c.price || 0}
                  </div>
                )}
              </div>

              {/* DELETE */}

              {isEditing && (
                <button
                  onClick={() => {
                    const updated = commitments.filter(
                      (_, index) => index !== i,
                    );

                    setCommitments(updated);
                  }}
                  style={{
                    marginTop: "15px",
                    border: "none",
                    background: "#dc2626",
                    color: "#fff",
                    padding: "10px 15px",
                    borderRadius: "8px",
                    cursor: "pointer",
                  }}
                >
                  🗑 Remove
                </button>
              )}
            </div>
          ))}
        </div>
      )}

      {/* TOTAL PRICE */}

      <div
        style={{
          marginTop: "35px",
        }}
      >
        <h3
          style={{
            color: "#5a140c",
            marginBottom: "18px",
            fontSize: "24px",
            fontWeight: "700",
          }}
        >
          Total Price
        </h3>

        <div
          style={{
            border: "1px solid #eaded8",
            borderRadius: "14px",
            padding: "22px",
            background: "#fff",
          }}
        >
          {isEditing ? (
            <input
              type="number"
              value={price}
              onChange={(e) => setPrice(e.target.value)}
              style={{
                width: "100%",
                padding: "14px",
                border: "1px solid #ddd",
                borderRadius: "8px",
                fontSize: "18px",
              }}
            />
          ) : (
            <div
              style={{
                color: "#7b1408",
                fontSize: "28px",
                fontWeight: "700",
              }}
            >
              ₹ {Number(finalTotal || 0).toLocaleString("en-IN")}
            </div>
          )}
        </div>
      </div>
    </ClientFlowLayout>
  );
}

export default CreateDocument;
